import axios from "axios";
import { getToken, getTokenHeader } from "../../../screen/auth/action";
import { getDashboardConfigUrl, getHomepageDataUrl } from "../Api";

export const getHomepageData = async (user_id = null) => {
  return new Promise(async (next) => {
      const token = await getToken();
      const params = user_id ? { user_id } : {}; 
      const response = await axios.get(getHomepageDataUrl(), {
        ...getTokenHeader(token),
        params,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const getDashboardConfigData = async ({
  manufacturer_id,
  user_esi_id,
}) => {
  return new Promise(async (next) => {
    try {
      const token = await getToken();
      const params = { manufacturer_id, user_esi_id };
      const { data } = await axios.get(getDashboardConfigUrl(), {
        ...getTokenHeader(token),
        params,
      });
      return next(data);
    } catch (err) {
      return next({ error: true, message: err?.message || 'Something went wrong' });
    }
  });
};
